import api from './api';

const paymentService = {
  // Inicializar pago
  initializePayment: async (appointmentId) => {
    try {
      const response = await api.post('/payments/init', { appointmentId });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Obtener estado
  getPaymentStatus: async (appointmentId) => {
    try {
      const response = await api.get(`/payments/status/${appointmentId}`);
      return response.data;
    } catch (error) {
      console.error('Error obteniendo estado del pago:', error);
      return { status: 'not-found' };
    }
  },
};

export default paymentService;
